module.exports = __webpack_public_path__ + "media/bootstrap-icons/volume-up-fill-e5649ad4.svg";